null


// WEBPACK FOOTER //
// /Volumes/workplace/commands/DescribeStreamSummaryCommand.ts